import { useTranslation } from 'react-i18next';
import Stat from './stat';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

function SellsStat({ data, previousData }) {
  const {t} = useTranslation()

  const isNoPeriodData = useSelector(
    (state) => state.meTicketData.isNoPeriodData
  );

  const percent = useMemo(() => {
    const previousValue = previousData?.summarySalesByPeriod;
    if (!previousValue) return null;
    return parseInt(
      ((data.summarySalesByPeriod - previousValue) / previousValue) * 100
    );
  }, [data.summarySalesByPeriod, previousData]);
  return (
    <div className={classNames({ 'opacity-25': isNoPeriodData })}>
      <Stat
        icon={'cash-coin'}
        mainLabel={t('ticketStatistic.salesSummary')}
        smallLabel={t('ticketStatistic.salesSummaryDescription')}
        value={data.summarySales}
        percentage={percent}
        currency={data.currency}
        dataByPeriod={data.summarySalesByPeriod}
      />
    </div>
  );
}

export default SellsStat
